export const appHasChangesSelector = (state) => state.unsavedChanges.hasChanges;
export const multipleEntitiesRegisterSelector = (state) => state.unsavedChanges.multipleEntitiesRegister;
